import React from "react";

const PickListComponentMap={
  accountPickListPopup:React.lazy(()=>import('../components/Account/AccountPickListPopup.js')),
  productPickListPopup:React.lazy(()=>import('../components/Product/ProductPickListPopup.js')),
  tankPickListPopup:React.lazy(()=>import('../components/Tank/TankPickListPopup.js')),
  alcoholLicensePickListPopup:React.lazy(()=>import('../components/AlcoholLicense/AlcoholLicensePickListPopup.js')),
  gtinPickListPopup:React.lazy(()=>import('../components/GTIN/GTINPickListPopup.js')),
  weekPickListPopup:React.lazy(()=>import('../components/Week/WeekPickListPopup.js')),
  manufacturingOrderBatchPickListPopup:React.lazy(()=>import('../components/ManufacturingOrder/ManufacturingOrderBatchPickListPopup.js')),
  manufacturingOrderSKUPickListPopup:React.lazy(()=>import('../components/ManufacturingOrder/ManufacturingOrderSKUPickListPopup.js')),
}

export const getPickListPopup=(pickListPopup)=>{
  return PickListComponentMap[pickListPopup]||null;
};